// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"e9ab5f49","97":"7bf4e459","126":"20fcb01a","144":"876fb018","230":"ef51f1b0","234":"0ae970e0","284":"4c7d4a0a","314":"7df7b40d","318":"35a1bddb","453":"57d639dc","529":"f07b2dda","582":"1dfe1c27","813":"7716f907","822":"e53f7393","887":"1dd082ab","996":"63433e27"}[chunkId] + ".chunk.js";
};